import React from "react";
import "./Marketing.css";

// Common
import Navbar from "../Common/Navbar";
import MarketingHero from "./Marketingspace/MarketingHero";
import MarketingFeatures from "./Marketingspace/MarketingFeatures";
import SeoToolsSection from "./Marketingspace/SeoToolsSection";
import HowMarketingWorks from "./Marketingspace/HowMarketingWorks";
import MarketingCTA from "./Marketingspace/MarketingCTA";

function Marketing() {
  return (
    <>
      <Navbar />

      <main className="marketing-page-wrapper">

        {/* BACKGROUND GLOW */}
        <div className="marketing-bg-glow marketing-glow-1"></div>
        <div className="marketing-bg-glow marketing-glow-2"></div>

        <div className="marketing-main-container">

          {/* HERO */}
          <MarketingHero />

          {/* FEATURES */}
          <MarketingFeatures />

          {/* SEO TOOLS */}
          <SeoToolsSection />

          {/* HOW IT WORKS */}
          <HowMarketingWorks />

          {/* CTA */}
          <MarketingCTA />

        </div>
      </main>
    </>
  );
}

export default Marketing;